import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Instagram, Facebook, Phone, Mail, MapPin } from 'lucide-react';

const Footer16 = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');

    const handleSubscribe = (e) => {
        e.preventDefault();
        if (email.trim()) {
            setEmail('');
        }
    };

    const collectionsLinks = [
        { label: 'Bridal Lehengas', path: '/template16/shop' },
        { label: 'Wedding Sarees', path: '/template16/shop' },
        { label: 'Reception Gowns', path: '/template16/shop' },
        { label: 'Bridal Jewelry', path: '/template16/shop' },
        { label: 'Bridal Accessories', path: '/template16/shop' },
    ];

    const customerCareLinks = [
        { label: 'Contact Us', path: '/template16/contact' },
        { label: 'Shipping Policy', path: '/template16/shipping-exchange' },
        { label: 'Returns & Exchange', path: '/template16/shipping-exchange' },
        { label: 'FAQs', path: '/template16/faqs' },
        { label: 'Track Order', path: '/template16/orders' },
    ];

    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=EB+Garamond:wght@400;500;600;700&family=Poppins:wght@300;400;500&display=swap');
            `}</style>

            <footer style={{ backgroundColor: '#7F1D1D', borderTop: '3px solid #B8860B' }}>
                {/* Main Footer Content */}
                <div
                    style={{
                        maxWidth: '1400px',
                        margin: '0 auto',
                        padding: '64px 24px',
                    }}
                    className="dulhan-footer-main"
                >
                    <div className="dulhan-footer-grid">
                        {/* Column 1: Brand */}
                        <div>
                            <h3
                                style={{
                                    fontFamily: "'EB Garamond', serif",
                                    fontSize: '32px',
                                    fontWeight: 600,
                                    color: '#B8860B',
                                    letterSpacing: '3px',
                                    margin: '0 0 16px 0',
                                }}
                            >
                                DULHAN
                            </h3>
                            <p
                                style={{
                                    fontFamily: "'Poppins', sans-serif",
                                    fontSize: '14px',
                                    color: '#FEF2E8',
                                    lineHeight: 1.7,
                                    margin: '0 0 24px 0',
                                    fontStyle: 'italic',
                                    fontWeight: 300,
                                }}
                            >
                                Where Bridal Dreams Come to Life
                            </p>
                            <div style={{ display: 'flex', gap: '12px' }}>
                                {[Instagram, Facebook].map((Icon, idx) => (
                                    <a
                                        key={idx}
                                        href="#"
                                        style={{
                                            width: '40px',
                                            height: '40px',
                                            border: '1px solid rgba(184, 134, 11, 0.4)',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            color: '#B8860B',
                                            transition: 'all 0.3s ease',
                                            textDecoration: 'none',
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.borderColor = '#B8860B';
                                            e.currentTarget.style.backgroundColor = 'rgba(184, 134, 11, 0.15)';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.borderColor = 'rgba(184, 134, 11, 0.4)';
                                            e.currentTarget.style.backgroundColor = 'transparent';
                                        }}
                                    >
                                        <Icon size={18} />
                                    </a>
                                ))}
                                <a
                                    href="#"
                                    style={{
                                        width: '40px',
                                        height: '40px',
                                        border: '1px solid rgba(184, 134, 11, 0.4)',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        color: '#B8860B',
                                        transition: 'all 0.3s ease',
                                        textDecoration: 'none',
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.borderColor = '#B8860B';
                                        e.currentTarget.style.backgroundColor = 'rgba(184, 134, 11, 0.15)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.borderColor = 'rgba(184, 134, 11, 0.4)';
                                        e.currentTarget.style.backgroundColor = 'transparent';
                                    }}
                                >
                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="M8 12a4 4 0 1 1 8 0c0 2.5-1.5 4.5-3 6l-1 3" />
                                        <path d="M12 2a10 10 0 1 0 4 19.2" />
                                    </svg>
                                </a>
                            </div>
                        </div>

                        {/* Column 2: Collections */}
                        <div>
                            <h4
                                style={{
                                    fontFamily: "'EB Garamond', serif",
                                    fontSize: '16px',
                                    fontWeight: 600,
                                    color: '#B8860B',
                                    letterSpacing: '2px',
                                    textTransform: 'uppercase',
                                    margin: '0 0 24px 0',
                                }}
                            >
                                Collections
                            </h4>
                            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                {collectionsLinks.map((link) => (
                                    <li key={link.label} style={{ marginBottom: '12px' }}>
                                        <span
                                            onClick={() => navigate(link.path)}
                                            style={{
                                                fontFamily: "'Poppins', sans-serif",
                                                fontSize: '14px',
                                                color: '#FEF2E8',
                                                cursor: 'pointer',
                                                transition: 'color 0.3s ease',
                                                textDecoration: 'none',
                                                fontWeight: 300,
                                            }}
                                            onMouseEnter={(e) => (e.target.style.color = '#B8860B')}
                                            onMouseLeave={(e) => (e.target.style.color = '#FEF2E8')}
                                        >
                                            {link.label}
                                        </span>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* Column 3: Customer Care */}
                        <div>
                            <h4
                                style={{
                                    fontFamily: "'EB Garamond', serif",
                                    fontSize: '16px',
                                    fontWeight: 600,
                                    color: '#B8860B',
                                    letterSpacing: '2px',
                                    textTransform: 'uppercase',
                                    margin: '0 0 24px 0',
                                }}
                            >
                                Customer Care
                            </h4>
                            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                {customerCareLinks.map((link) => (
                                    <li key={link.label} style={{ marginBottom: '12px' }}>
                                        <span
                                            onClick={() => navigate(link.path)}
                                            style={{
                                                fontFamily: "'Poppins', sans-serif",
                                                fontSize: '14px',
                                                color: '#FEF2E8',
                                                cursor: 'pointer',
                                                transition: 'color 0.3s ease',
                                                textDecoration: 'none',
                                                fontWeight: 300,
                                            }}
                                            onMouseEnter={(e) => (e.target.style.color = '#B8860B')}
                                            onMouseLeave={(e) => (e.target.style.color = '#FEF2E8')}
                                        >
                                            {link.label}
                                        </span>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* Column 4: Get In Touch */}
                        <div>
                            <h4
                                style={{
                                    fontFamily: "'EB Garamond', serif",
                                    fontSize: '16px',
                                    fontWeight: 600,
                                    color: '#B8860B',
                                    letterSpacing: '2px',
                                    textTransform: 'uppercase',
                                    margin: '0 0 24px 0',
                                }}
                            >
                                Get In Touch
                            </h4>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                    <Mail size={16} style={{ color: '#B8860B', flexShrink: 0 }} />
                                    <span style={{ fontFamily: "'Poppins', sans-serif", fontSize: '14px', color: '#FEF2E8', fontWeight: 300 }}>
                                        hello@dulhan.com
                                    </span>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                    <Phone size={16} style={{ color: '#B8860B', flexShrink: 0 }} />
                                    <span style={{ fontFamily: "'Poppins', sans-serif", fontSize: '14px', color: '#FEF2E8', fontWeight: 300 }}>
                                        +91 98765 43210
                                    </span>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                                    <MapPin size={16} style={{ color: '#B8860B', flexShrink: 0, marginTop: '2px' }} />
                                    <span style={{ fontFamily: "'Poppins', sans-serif", fontSize: '14px', color: '#FEF2E8', lineHeight: 1.6, fontWeight: 300 }}>
                                        Mumbai, Maharashtra, India
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Bottom Bar */}
                <div style={{ backgroundColor: '#691717', borderTop: '1px solid rgba(184, 134, 11, 0.2)' }}>
                    <div
                        style={{
                            maxWidth: '1400px',
                            margin: '0 auto',
                            padding: '24px',
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                flexWrap: 'wrap',
                                gap: '16px',
                            }}
                            className="dulhan-footer-bottom"
                        >
                            <p style={{ fontFamily: "'Poppins', sans-serif", fontSize: '12px', color: '#FEF2E8', margin: 0, fontWeight: 300, opacity: 0.7 }}>
                                &copy; 2026 DULHAN. All rights reserved.
                            </p>
                            <p style={{ fontFamily: "'EB Garamond', serif", fontSize: '13px', color: '#B8860B', margin: 0, fontStyle: 'italic' }}>
                                Crafted with love for every bride
                            </p>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                                <svg width="36" height="24" viewBox="0 0 36 24" fill="none">
                                    <rect width="36" height="24" rx="2" fill="#691717" stroke="rgba(184,134,11,0.3)" />
                                    <text x="18" y="14" textAnchor="middle" fill="#B8860B" fontSize="8" fontWeight="bold" fontFamily="Poppins, sans-serif">VISA</text>
                                </svg>
                                <svg width="36" height="24" viewBox="0 0 36 24" fill="none">
                                    <rect width="36" height="24" rx="2" fill="#691717" stroke="rgba(184,134,11,0.3)" />
                                    <circle cx="15" cy="12" r="5" fill="#B8860B" opacity="0.4" />
                                    <circle cx="21" cy="12" r="5" fill="#B8860B" opacity="0.4" />
                                </svg>
                                <svg width="36" height="24" viewBox="0 0 36 24" fill="none">
                                    <rect width="36" height="24" rx="2" fill="#691717" stroke="rgba(184,134,11,0.3)" />
                                    <text x="18" y="14" textAnchor="middle" fill="#B8860B" fontSize="7" fontWeight="bold" fontFamily="Poppins, sans-serif">UPI</text>
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Responsive Styles */}
                <style>{`
                    .dulhan-footer-grid {
                        display: grid;
                        grid-template-columns: repeat(4, 1fr);
                        gap: 48px;
                    }
                    @media (max-width: 768px) {
                        .dulhan-footer-grid {
                            grid-template-columns: 1fr;
                            gap: 40px;
                        }
                        .dulhan-footer-main {
                            padding: 40px 24px !important;
                        }
                        .dulhan-footer-bottom {
                            flex-direction: column;
                            align-items: center !important;
                            text-align: center;
                        }
                    }
                    @media (min-width: 769px) and (max-width: 1024px) {
                        .dulhan-footer-grid {
                            grid-template-columns: repeat(2, 1fr);
                        }
                    }
                `}</style>
            </footer>
        </>
    );
};

export default Footer16;
